import { useEffect, useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap"
import { OrganisationAddEdit } from "./common/formsCreateEdit/organisationAddEdit";
import { useParams, useNavigate } from "react-router-dom";
import Loading from './common/loading';
import useApi from '../utilities/useApi';
import stringUtilities from "../utilities/stringUtilities";
export default function EditOrganisation () {
    const { api } = useApi();
    const navigate = useNavigate();
    const {organisationId} = useParams();
    const [updateOrg, setUpdateOrg] = useState(null);
    const [name, setName] = useState(null);
    const [headerImage, setHeaderImage] = useState(null);
    const [footerImage, setFooterImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null)

    const getOrganisation = () => {
        setIsLoading(true)
        api.getOrganisationalUnit(
            organisationId,
            data => {
                setUpdateOrg(data);
                setName(data.name)
                setHeaderImage({
                    filename: !stringUtilities.isNullOrEmpty(data.mapHeader) ? data.mapHeader.split("/").pop() : null,
                    fullPath: data.mapHeader,
                })
                setFooterImage({
                    filename: !stringUtilities.isNullOrEmpty(data.mapFooter) ? data.mapFooter.split("/").pop() : null,
                    fullPath: data.mapFooter,
                })
                setIsLoading(false)
            },
            error => console.log(error),
        )
    }

    const onSave = () => {    
        setIsLoading(true);
        api.updateOrganisationalUnit(
            updateOrg, 
            name, 
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                    setIsLoading(false)
                } else {
                    navigate("/organisations")
                }
            },
            error => {
                setErrorMessage(error)
                setIsLoading(false)
            }
        )
    }

    useEffect(() => getOrganisation(), [])

    return (
        <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2'>
            <Row>
                <Col className='mb-5'>
                    <div className='d-flex justify-content-between my-5'>
                        <h1 className="h2 m-0">Edit Organisation</h1>
                    </div>
                    <div>
                        {
                            isLoading 
                            ? <Loading />
                            : <OrganisationAddEdit 
                                name={name}
                                setName={setName}
                                id={organisationId}
                                headerImage={headerImage}
                                setHeaderImage={setHeaderImage}
                                footerImage={footerImage}
                                setFooterImage={setFooterImage}
                                handleCancel={() => navigate("/organisations")}
                                handleSubmit={() => onSave()}
                            />
                        }
                    </div>
                </Col>
            </Row>
            <Modal show={ !stringUtilities.isNullOrEmpty(errorMessage) } onHide={ () => setErrorMessage(null) } centered>
                <Modal.Header>
                    <Modal.Title className="d-flex gap-2 align-items-center"><i className='fi-alert-triange text-danger'/>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className='m-0'>{ errorMessage }</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant='secondary' onClick={ () => setErrorMessage(null)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </Container>
    )
}